class CacheServ {
    _cache = {}

    set (key, value, saveToLocal) {
        this._cache[key] = value
        if (saveToLocal) {
            let saveString = typeof value === 'object' ? JSON.stringify(value) : value
            sessionStorage.setItem(key, saveString)
        }
        return this
    }

    get (key) {
        let ret = this._cache[key]
        if (ret === undefined || ret === null) {
            ret = sessionStorage.getItem(key)
            try {
                ret = JSON.parse(ret)
            } catch (e) {

            }
            this._cache[key] = ret
        }
        return ret
    }

    localSet (key, value, saveToLocal) {
        this._cache[key] = value
        if (saveToLocal) {
            let saveString = typeof value === 'object' ? JSON.stringify(value) : value
            localStorage.setItem(key, saveString)
        }
        return this
    }

    localGet (key) {
        let ret = this._cache[key]
        if (ret === undefined || ret === null) {
            ret = localStorage.getItem(key)
            try {
                ret = JSON.parse(ret)
            } catch (e) {

            }
            this._cache[key] = ret
        }
        return ret
    }
}

// {"account":"18615704929","appToken":"","cityId":null,"createTime":"2017-06-29 13:54:30","email":"","freeze":1,"id":10389,"imUser":{"account":"10389","nickname":"18615704929","token":"75a6e5993aefba4f6cb07254637a6133"},"loginTime":"2017-06-29 17:27:57","name":"18615704929","password":"41ccdc3c4e812f879581852261b91e28","phoneNumber":"18615704929","provinceId":null,"updateTime":"2017-06-29 17:27:57","webToken":"1lg7c7r4sv454yb1jyame9a3r","wxToken":""}
export default new CacheServ()



// WEBPACK FOOTER //
// ./src/service/cacheServ.js